'use strict';

import Element from './element';
import Toolbar from './toolbar';
import Panel from './panel';
import View3D from './view3d';
import View2D from './view2d';
import Editor from './editor';

export default {
	Element,
	Toolbar,
	Panel,
	View3D,
	View2D,
	Editor
};
